import React from "react";
import ReactDOM from "react-dom/client";
import App from "./pages/Home";
import "./index.scss";
import "@/utils/rem.js"; // rem 适配

import { getEnvConfig } from "@/utils/getEnv";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement!);

const { env } = getEnvConfig();
console.log("env:", env);

root.render(<App />);
